const components = [
	{
		label: "便捷记事本",
		img: "./images/note.svg",
		type: "note",
	},
	{
		label: "时间进度条",
		img: "./images/timeProgress.png",
		type: "timeProgress",
	},
	{
		label: "Markdown编辑器",
		img: "./images/markdownPre.svg",
		type: "markdown",
	},
	{
		label: "快捷翻译器",
		img: "./images/translatePre.svg",
		type: "translatelite",
	},
	{
		label: "实时天气",
		img: "./images/localWeather.svg",
		type: "localWeather",
	},
	{
		label: "实时热榜",
		img: "./images/hotEvent.svg",
		type: "hotEventList",
	},
	{
		label: "节假日提醒",
		img: "./images/festivalRemind.svg",
		type: "festivalRemind",
	},
];

export default components;
